import { Injectable } from '@angular/core';
import { PGUtilities } from '../utilities/pg-utilities';

@Injectable({
  providedIn: 'root'
})
export class IncludeJsService {

    constructor() { }

    included:{ 
        [url:string]: { 
            status: 'loading'|'success'|'error', 
            wait:Array<{ 
                resolve: () => void, 
                reject: () => void 
            }> 
        } 
    } = {}

    include(file:string, attrs?:{[name:string]:string}) {
        return new Promise<void>((resolve, reject) => {
            if(this.included[file] == null) {
                this.included[file] = {
                    status: 'loading',
                    wait: []
                }

                PGUtilities.loadScript(file, attrs).then(() => {
                    this.included[file].status = 'success'

                    for(let _item of this.included[file].wait) {
                        _item.resolve();
                    }

                    this.included[file].wait = []
                }, () => {
                    this.included[file].status = 'error'

                    for(let _item of this.included[file].wait) {
                        _item.reject();
                    }

                    this.included[file].wait = []
                })
            }
            
            if(this.included[file].status == 'loading') {
                this.included[file].wait.push({ resolve: resolve, reject: reject })
            }
            else {
                if(this.included[file].status == 'success') resolve();
                else reject()
            }
        })
    }
}
